/* from: 
    HSLToRGB - https://www.30secondsofcode.org/js/s/hsl-to-rgb/
*/
/**
    @param {number} h hue color (0-360)
    @param {number} s saturation color (0-100)
    @param {number} l lightness color (0-100)
    @returns {[red, green, blue]} array of RGB
    @description convert hsl to rgb
*/
const HSLToRGB = (h = 0, s = 0, l = 0) => {
  s /= 100;
  l /= 100;
  const k = (n) => (n + h / 30) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n) =>
    l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  const f2 = (n) => Math.round(255 * f(n));
  return [f2(0), f2(8), f2(4)];
};

export default HSLToRGB;
